import { render, staticRenderFns } from "./FullView2021.vue?vue&type=template&id=b8ec8e6e&scoped=true"
import script from "./FullView2021.vue?vue&type=script&lang=js"
export * from "./FullView2021.vue?vue&type=script&lang=js"
import style0 from "./FullView2021.vue?vue&type=style&index=0&id=b8ec8e6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ec8e6e",
  null
  
)

export default component.exports